

export const getDaysDifference = (inputDate) => {
  const inputDateObj = new Date(inputDate);
  if (isNaN(inputDateObj.getTime())) {
    throw new Error("Invalid date format");
  }

  const now = new Date();

  // Convert both dates to local date at midnight to avoid timezone issues
  const inputLocalDate = new Date(inputDateObj.getFullYear(), inputDateObj.getMonth(), inputDateObj.getDate());
  const nowLocalDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  const diffTime = nowLocalDate.getTime() - inputLocalDate.getTime();
  const daysDifference = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  return daysDifference;
}